import React from "react";
import { ForgetPasswordStep2Styled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const ForgetPasswordStep2 = ({ onSubmit }) => {
  const { t } = useTranslation(["common"]);
  const schema = yup.object().shape({
    test: yup.string().required("New password is required"),
  });

  const {
    control,
    handleSubmit,
    // formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <ForgetPasswordStep2Styled>
      <div className="register_header">{t("Check your email", { ns: "common" })}</div>
      <div className="register_title">
        เราได้ส่งอีเมลถึงคุณ
        <br />
        ตรวจสอบกล่องจดหมายของคุณและทำตาม
        <br />
        คำแนะนำเพื่อรีเซ็ตรหัสผ่านบัญชีของคุณ
      </div>
      <div className="register_email">admin001@example.com</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.TextField
              theme_standard2
              className="otp_code"
              label={t("Enter OTP code", { ns: "common" })}
              placeholder="เว้นไว้ใช้ lib แทน"
              {...field}
              // placeholder={t('test')}
              // errors={errors.phone?.message}
            />
          )}
          name="test"
          defaultValue=""
        />
      </form>
      <div className="register_button">
        <Buttons.BgStandard label={t("Send password reset request", { ns: "common" })} />
      </div>
      <div className="back">
        <div className="back_text">คุณไม่ได้รับอีเมลใช่ไหม</div>
        <button className="back_button">{t("Resend email", { ns: "common" })}</button>
      </div>
    </ForgetPasswordStep2Styled>
  );
};

ForgetPasswordStep2.propTypes = {};

export default ForgetPasswordStep2;
